<template>
    <span class="tag is-light">{{ role }}</span>
</template>

<script>
export default {
    name: 'Role',
    props: ['role'],
};
</script>

<style>
    .tag {margin-right: 2px;}
</style>
